import { ApolloClient, InMemoryCache, NormalizedCacheObject } from '@apollo/client'
import { SupportedChainId } from 'constants/chains'

const CHAIN_SUBGRAPH_URL: Record<number, string> = {
  [SupportedChainId.ZK_SYNC]: 'https://api.studio.thegraph.com/query/4540/wagmi-zksync-era-backup/v0.0.10',
  [SupportedChainId.FANTOM]: 'https://api.thegraph.com/subgraphs/name/0xfantaholic/wagmi-fantom',
  [SupportedChainId.ARBITRUM]: 'https://api.studio.thegraph.com/query/4540/wagmi-arbitrum/version/latest',
}

export const clients: { [key in SupportedChainId]: ApolloClient<NormalizedCacheObject> } = {
  [SupportedChainId.ZK_SYNC]: new ApolloClient({
    cache: new InMemoryCache(),
    uri: CHAIN_SUBGRAPH_URL[SupportedChainId.ZK_SYNC],
  }),
  [SupportedChainId.FANTOM]: new ApolloClient({
    cache: new InMemoryCache(),
    uri: CHAIN_SUBGRAPH_URL[SupportedChainId.FANTOM],
  }),
  [SupportedChainId.ARBITRUM]: new ApolloClient({
    cache: new InMemoryCache(),
    uri: CHAIN_SUBGRAPH_URL[SupportedChainId.ARBITRUM],
  }),
}
